@if (vm && vm.groups) {
    @for (group of vm.groups; track $index) {
        <section class="fixture-group">
            <header [class.expanded]="expandedGroups.get(group)" (click)="toggleGroupExpanded(group)">
                <span>{{ group.groupName }}</span>
                <a class="icon icon-expand antepost-fixture-list__expand-arrow">
                    <vn-icon class="antepost-expand-arrow" size="14" [name]="expandedGroups.get(group) ? 'theme-up' : 'theme-down'" />
                </a>
            </header>
            @if (expandedGroups.get(group)) {
                @for (fixture of group.fixtures; track $index) {
                    <a class="fixture-group-item ms-active-highlight" [href]="fixture.url">
                        <span>{{ fixture.name | msTranslate }}</span>
                        @if (fixturePromos[fixture.id] || meetingPromos[group.fixtureGroup.tag.id]) {
                            <ms-promotion-badge />
                        }
                    </a>
                }
            }
        </section>
    }
    @if (vm.groups.length === 0) {
        <ms-error [links]="false" [message]="sitecore.fixture.antepost.ErrorNoAntepostGroup" [severity]="'info'" />
    }
}
